import apiClient from "./client";
const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";

export async function getBlogTopics() {
  return apiClient.get("/blog/topics");
}

export async function getBlogTags(q) {
  const params = q ? `?q=${encodeURIComponent(q)}` : "";
  return apiClient.get(`/blog/tags${params}`);
}

export async function getBlogPosts({ topic, tag, page = 1, limit = 20 } = {}) {
  const params = new URLSearchParams();
  if (topic) params.set("topic", topic);
  if (tag) params.set("tag", tag);
  params.set("page", String(page));
  params.set("limit", String(limit));
  return apiClient.get(`/blog?${params.toString()}`);
}

export async function getBlogPost(slug) {
  return apiClient.get(`/blog/${encodeURIComponent(slug)}`);
}

export async function getRelatedBlogPosts(slug) {
  return apiClient.get(`/blog/${encodeURIComponent(slug)}/related`);
}

export async function submitBlogPost(data) {
  return apiClient.post("/submissions/blog", data);
}

export async function getMyBlogPost(id) {
  return apiClient.get(`/submissions/blog/${id}`);
}

export async function updateMyBlogPost(id, data) {
  return apiClient.patch(`/submissions/blog/${id}`, data);
}

export async function uploadBlogCoverImage(file) {
  const formData = new FormData();
  formData.append("image", file);
  const headers = {};
  if (apiClient.accessToken) {
    headers.Authorization = `Bearer ${apiClient.accessToken}`;
  }
  const response = await fetch(`${API_BASE}/blog/upload-cover`, {
    method: "POST",
    headers,
    body: formData,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Cover upload failed");
  }
  return data;
}

export async function getBlogComments(slug) {
  return apiClient.get(`/blog/${encodeURIComponent(slug)}/comments`);
}

export async function createBlogComment(slug, data) {
  return apiClient.post(`/blog/${encodeURIComponent(slug)}/comments`, data);
}

export async function updateBlogComment(slug, commentId, data) {
  return apiClient.patch(`/blog/${encodeURIComponent(slug)}/comments/${commentId}`, data);
}

export async function deleteBlogComment(slug, commentId) {
  return apiClient.delete(`/blog/${encodeURIComponent(slug)}/comments/${commentId}`);
}

export async function toggleBlogPostThumbsUp(slug) {
  return apiClient.post(`/blog/${encodeURIComponent(slug)}/thumbs-up`);
}

export async function toggleBlogCommentThumbsUp(slug, commentId) {
  return apiClient.post(`/blog/${encodeURIComponent(slug)}/comments/${commentId}/thumbs-up`);
}

export async function getAdminBlogPosts() {
  return apiClient.get("/blog/admin/posts");
}

export async function getAdminBlogPostPreview(id) {
  return apiClient.get(`/blog/admin/posts/${id}/preview`);
}

export async function createAdminBlogPost(data) {
  return apiClient.post("/blog/admin/posts", data);
}

export async function updateAdminBlogPost(id, data) {
  return apiClient.patch(`/blog/admin/posts/${id}`, data);
}

export async function deleteAdminBlogPost(id) {
  return apiClient.delete(`/blog/admin/posts/${id}`);
}

export async function updateBlogPostPermissions(id, readGroups) {
  return apiClient.put(`/blog/admin/posts/${id}/permissions`, { readGroups });
}

export async function getAdminBlogTopics() {
  return apiClient.get("/blog/admin/topics");
}

export async function createAdminBlogTopic(data) {
  return apiClient.post("/blog/admin/topics", data);
}

export async function patchAdminBlogTopic(id, data) {
  return apiClient.patch(`/blog/admin/topics/${id}`, data);
}
